import { render, staticRenderFns } from "./ReviewsPieChart.vue?vue&type=template&id=568f8fa7&scoped=true&"
import script from "./ReviewsPieChart.vue?vue&type=script&lang=js&"
export * from "./ReviewsPieChart.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsPieChart.vue?vue&type=style&index=0&id=568f8fa7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568f8fa7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
